import { render, staticRenderFns } from "./News_Video.vue?vue&type=template&id=2340c6b6"
import script from "./News_Video.vue?vue&type=script&lang=js"
export * from "./News_Video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports